<template>
  <div v-if="shouldRender" class="py-1">
    <file-item-card
      :file-name="decodedFileName"
      :extension="extension"
      :icon-color-class="getFileIconColor(fileType, getFileExtension(url))"
      @image-error="onImageError(url)"
    >
      <template #action>
        <a
          :disabled="imageErrors[url]"
          :title="$t('CONVERSATION.DOWNLOAD')"
          :href="url"
          target="_blank"
          rel="noreferrer noopener nofollow"
          class="w-11 h-11 flex items-center justify-center button-naked shrink-0 transition-colors"
        >
          <span class="material-symbols-outlined text-[22px]">download</span>
        </a>
      </template>
    </file-item-card>
  </div>
</template>

<script>
import FileItemCard from 'dashboard/components/widgets/FileItemCard.vue';
import { getFileExtension, getFileIconColor } from 'dashboard/helper/fileUtils';

export default {
  components: { FileItemCard },
  props: {
    url: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imageErrors: {},
    };
  },
  computed: {
    shouldRender() {
      return this.url.length > 0;
    },
    decodedFileName() {
      if (this.url) {
        const filename = this.url.substring(this.url.lastIndexOf('/') + 1);
        return decodeURI(filename) || this.$t('CONVERSATION.UNKNOWN_FILE_TYPE');
      }
      return this.$t('CONVERSATION.UNKNOWN_FILE_TYPE');
    },
    extension() {
      const parts = this.decodedFileName.split('.');
      return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : '';
    },
  },
  methods: {
    getFileExtension,
    getFileIconColor,
    onImageError(url) {
      this.$set(this.imageErrors, url, true);
    },
  },
};
</script>
